<div class="rules-container" [ngClass]="{ 'sub-panel-active': this.activeSubPanel }">
	<div class="rules-filters" #rulesContainer>
		<h6>
			<button
				class="btn btn-sm rule-set-button"
				type="button"
				[disabled]="disableActionButtons"
				(click)="openRuleSet()"
			>
				Checklist <i class="fas fa-cog"></i>
			</button>
		</h6>
		<div class="actions d-inline-block float-right">
			<button
				class="btn btn-sm btn-light"
				*ngIf="canCreateRule()"
				[disabled]="disableActionButtons"
				(click)="onCreateRule()"
				title="Create New Rule"
			>
				<i class="fas fa-plus"></i>
			</button>
			<span
				(click)="onTypeFiltersChange(RULE_MESSAGE_TYPE.Info)"
				[ngClass]="{ active: containsFilter(RULE_MESSAGE_TYPE.Info) }"
				title="Info Rules"
				class="badge badge-primary"
			>
				{{ rulesInfo }}
			</span>
			<span
				(click)="onTypeFiltersChange(RULE_MESSAGE_TYPE.Warning)"
				[ngClass]="{ active: containsFilter(RULE_MESSAGE_TYPE.Warning) }"
				title="Warning Rules"
				class="badge badge-warning"
			>
				{{ rulesWarning }}
			</span>
			<span
				(click)="onTypeFiltersChange(RULE_MESSAGE_TYPE.Error)"
				[ngClass]="{ active: containsFilter(RULE_MESSAGE_TYPE.Error) }"
				title="Error Rules"
				class="badge badge-danger"
			>
				{{ rulesError }}
			</span>
		</div>
		<div class="content-sub-header">
			<div class="rules-filter-content-bottom-wrapper">
				<h6 class="text-uppercase rules-filter-content-bottom">
					<button
						class="btn btn-sm rule-set-button check-set"
						type="button"
						(click)="toggleViewOnlyUncheckedRules()"
					>
						<i
							[ngClass]="{
								'far fa-square': !viewOnlyUncheckedRules,
								'fas fa-check-square': viewOnlyUncheckedRules
							}"
						></i>

						Unchecked rules
					</button>
				</h6>
			</div>
			<div class="filter-options">
				<cv-multiselect
					[options]="filterOptions"
					[values]="filterValues"
					[optionText]="'name'"
					[optionValue]="'name'"
					[placeholder]="'Filter By'"
					(valuesChange)="onFilterRulesChange($event)"
				>
				</cv-multiselect>
			</div>
			<div
				class="notification-actions  content-sub-header__notification rules-filter-content-bottom"
				[ngClass]="{
					'conent-sub-header__notification-large':
						rulesNotifications && rulesNotifications.length > 99
				}"
				*ngIf="!disableActionButtons"
			>
				<button
					class="btn btn-sm btn-light"
					[disabled]="!rulesNotifications || !rulesNotifications.length"
					(click)="onOpenNotificationsRule()"
				>
					<i class="far fa-bell rules-updated">
						<span
							*ngIf="rulesNotifications && rulesNotifications.length"
							class="badge badge-pill badge-info rules-updated-notification"
							[ngClass]="{ 'rules-updated-notification-large': rulesNotifications.length > 99 }"
							>{{ rulesNotifications.length }}</span
						>
					</i>
				</button>
			</div>
		</div>
	</div>
	<div class="rules-wrapper scrollable">
		<div class="rules-force-execution-indicator" *ngIf="isRunningRules()">
			<div class="text-center"><i class="fas fa-spinner fa-pulse fa-fw'"></i></div>
			<div class="text-center">
				<div class="rules-force-execution-indicator__text">Running Rules, Please Wait</div>
			</div>
		</div>
		<cv-rule-component
			*ngFor="let rule of (rules | orderRuleBy: orderInboxModel.formType)"
			[rule]="rule"
			[status]="rule.status"
			[viewOnlyUncheckedRules]="viewOnlyUncheckedRules"
			[disabledActions]="disableActionButtons || isRunningRules()"
			(selected)="onRuleSelected($event)"
			(addComment)="onAddComment($event)"
			(addStip)="onAddStip($event)"
			(viewComments)="onViewComments($event)"
			(viewStips)="onViewStips($event)"
			(updateStatus)="onRuleUpdated($event)"
			[active]="selectedRule && selectedRule.name === rule.name"
		>
		</cv-rule-component>
		<div *ngIf="!rules || !rules.length" class="empty-rules-message">
			<div>
				<label class="no-results">No rules available</label>
			</div>
		</div>
	</div>

	<div [@sideExpansion]="{ value: currentTransitionState }" class="rule-comments-container">
		<cv-rule-notifications
			*ngIf="
				currentTransitionState === TRANSITION_STATE.IS_OPEN &&
				activeSubPanel &&
				activeSubPanel === SUB_PANEL_TYPE.VIEW_RULE_NOTIFICATIONS
			"
			[ruleLog]="rulesNotifications"
			(cancel)="toggleSubPanel(false)"
		>
		</cv-rule-notifications>
		<cv-rule-create-component
			*ngIf="
				currentTransitionState === TRANSITION_STATE.IS_OPEN &&
				activeSubPanel &&
				activeSubPanel === SUB_PANEL_TYPE.CREATE_RULE
			"
			[targets]="data.targets.data"
			[primaryTargets]="data.targets.primary"
			(saved)="onRuleCreated($event, true)"
			(failed)="onRuleCreated($event, false)"
			(cancel)="toggleSubPanel(false)"
		>
		</cv-rule-create-component>
		<cv-rule-comment-create-component
			*ngIf="
				currentTransitionState === TRANSITION_STATE.IS_OPEN &&
				activeSubPanel &&
				activeSubPanel === SUB_PANEL_TYPE.ADD_COMMENT
			"
			[rule]="subPanelSelectedRule"
			(saved)="onCommentAdded($event, true)"
			(failed)="onCommentAdded($event, false)"
			(cancel)="toggleSubPanel(false)"
		>
		</cv-rule-comment-create-component>
		<cv-rule-comment-stip-view-component
			*ngIf="
				currentTransitionState === TRANSITION_STATE.IS_OPEN &&
				activeSubPanel &&
				activeSubPanel === SUB_PANEL_TYPE.VIEW_COMMENTS_AND_STIPS
			"
			[rule]="subPanelSelectedRule"
			[viewMode]="viewCommentsMode"
			[disableAdd]="disableAddForCommentsAndStipsPanel"
			(addComment)="onAddCommentFromView($event)"
			(deleteComments)="onDeleteComments($event)"
			(deleteStips)="onDeleteStips($event)"
			(addStip)="onAddStipFromView($event)"
			(closed)="toggleSubPanel(false)"
		>
		</cv-rule-comment-stip-view-component>
		<cv-rule-stip-create-component
			*ngIf="
				currentTransitionState === TRANSITION_STATE.IS_OPEN &&
				activeSubPanel &&
				activeSubPanel === SUB_PANEL_TYPE.ADD_STIP
			"
			[rule]="subPanelSelectedRule"
			(saved)="onStipAdded($event, true)"
			(failed)="onStipAdded($event, false)"
			(cancel)="toggleSubPanel(false)"
		>
		</cv-rule-stip-create-component>
	</div>

	<cv-rule-set></cv-rule-set>
</div>
